import { parseDayIso } from '../../../shared/lib/schedule';

const weekdayFormatter = new Intl.DateTimeFormat('de-DE', { weekday: 'long' });
const dateFormatter = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit' });

interface Props {
  dayIso: string;
  isToday: boolean;
  onOpenDay: (dayIso: string) => void;
}

/** `Montag` over `18.08.` — and the shortest way into that day's board. */
export const WeekDayHeader = ({ dayIso, isToday, onOpenDay }: Props) => {
  const date = parseDayIso(dayIso);

  return (
    <button
      type="button"
      onClick={() => onOpenDay(dayIso)}
      className={[
        'flex flex-col items-center gap-0.5 border-b border-r border-slate-200 px-2 py-3 w-full',
        'transition-colors hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#004494]',
        isToday ? 'bg-[#004494]/[0.06]' : 'bg-white',
      ].join(' ')}
    >
      <span
        className={`font-['PT_Sans'] text-[15px] font-bold leading-5 ${
          isToday ? 'text-[#004494]' : 'text-slate-900'
        }`}
      >
        {date ? weekdayFormatter.format(date) : dayIso}
      </span>
      {/* `de-DE` numeric dates already end in a dot — `17.08.` — so none is appended here. */}
      <span className="font-['Roboto'] text-[12px] leading-4 text-zinc-500">
        {date ? dateFormatter.format(date) : ''}
      </span>
    </button>
  );
};
